<template>
  <div>
    <div class="st-info-line">
      <div class="st-label">
        <div>ご注文点数</div>
      </div>
      <div class="st-value">
        <div>{{totalStock}}</div>
      </div>
    </div>

    <div class="st-pad-20"></div>

    <div class="st-info-line">
      <div class="st-label">
        <div>商品合計</div>
      </div>
      <div class="st-value">
        <div>
          {{ totalPrice | currency }}&nbsp;<span>(税込)</span>
        </div>
      </div>
    </div>
    <div class="st-info-line" v-if="discountCouponAmount">
      <div class="st-label">
        <div>クーポンコード:{{ savedCouponCode }}</div>
      </div>
      <div class="st-value">
        <div>
          - {{ discountCouponAmount | currency }}
        </div>
      </div>
    </div>
    <div class="st-info-line">
      <div class="st-label">
        <div>配送料</div>
      </div>
      <div class="st-value">
        <div>
          {{ shippingCharge | currency }}&nbsp;<span>(税込)</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      savedCouponCode: state => state.cart.input.couponCode,
      discountCouponAmount: state => state.cart.remote.discountCouponAmount
    }),
    ...mapGetters([
      'totalStock',
      'totalPrice',
      'shippingCharge'
    ])
  }
}
</script>
